export default __webpack_public_path__ + "static/media/1918.434475b9.png";